import React, { useEffect, useState } from 'react';

import { InputLabel } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { TimePeriodDropDown } from 'components/ObjectiveTagList/TagsList';

import { getTimeBoundTimePeriods } from 'services/admin';

import { Typography12 } from 'uiToolkit/Typography';

import { useObjectiveSidepanel } from '../context/ObjectiveSidePanelContext';

const ObjectiveTimeline = ({ selectedTimeBoundPeriod = null, disabled }) => {
  // context hooks
  const { state, setTimeboundDetails } = useObjectiveSidepanel();
  let { timeBoundDetails } = state ?? {};
  if ((timeBoundDetails?.timelineTag ?? null) === null) {
    timeBoundDetails = selectedTimeBoundPeriod;
  }

  // timeperiod states
  const [loadingTimeline, setLoadingTimeline] = useState(true);
  const [timePeriodData, setTimePeriodData] = useState([]);

  const getTimePeriodsData = async () => {
    try {
      setLoadingTimeline(true);
      const timePeriodData = await getTimeBoundTimePeriods();
      const { previous, current, next, other } = timePeriodData;

      setTimePeriodData(timePeriodData);
      const allTimePeriods = [previous, current, next, ...other].filter((item) => item !== null);

      setTimeboundDetails(allTimePeriods.find((opt) => opt.timelineTag === timeBoundDetails?.timelineTag));
    } catch (err) {
      console.error('Error loading timeline list : ', err);
    } finally {
      setLoadingTimeline(false);
    }
  };

  useEffect(() => {
    getTimePeriodsData();
  }, []);

  if (loadingTimeline) {
    return <Skeleton />;
  }

  return (
    <InputLabel htmlFor="objective-timeline-field">
      <Typography12 bottomGutter={1}>Period*</Typography12>

      <TimePeriodDropDown
        timePeriodData={timePeriodData}
        selectedTimeBoundPeriod={timeBoundDetails || null}
        setSelectedTimeBoundPeriod={(timeBoundPeriod) => setTimeboundDetails(timeBoundPeriod)}
        width="100%"
        disabled={disabled}
        isStyle2
      />
    </InputLabel>
  );
};

export default ObjectiveTimeline;
